import React, { PureComponent } from 'react'

class MapFullscreen extends PureComponent {
    render() {
        const { onClick, icon, disabled } = this.props
        const zoomStyle = {
            height: '31.5px',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            outline: 'none',
        }

        return (
            <div
                onClick={onClick}
                style={Object.assign({}, zoomStyle, disabled ? { opacity: 0.4 } : { cursor: 'pointer' })}
            >
                <img src={icon} style={{ outline: 'none' }} />
            </div>
        )
    }
}

export default MapFullscreen
